<template>
  <div class="nx-authorization-permissions-editor">
    <div class="nx-authorization-permissions-editor__header" :style="style">
      <h2 class="nx-form-legend"></h2>
      <v-btn flat small color="secondary" @click="wizard = true">{{
        $t('message.permissions.buttons.create') }}
      </v-btn>
    </div>
    <v-tabs v-model="tab" dark v-if="value">
      <v-tab v-for="resource in resources" :key="resource" ripple>
        {{ $t(`message.permissions.resources.${resource}`) }}
      </v-tab>
      <v-tab-item v-for="resource in resources" :key="resource">
        <v-data-table
            :headers="resourceHeaders(resource)"
            :items="resourcePermissions(resource)"
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <nx-resource-row-table :resource="resource" :value="props.item"></nx-resource-row-table>
            <td class="justify-center layout px-0">
              <v-btn icon flat color="primary"
                     @click="deletePermission(resource, props.item)"
                     v-if="props.item.origin === 'individual'">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="wizard" width="600" lazy>
      <nx-authorization-permissions-wizard
          @input="onInput"
          value="value"
          :default-resource="currentResource"
          @cancel="wizard = false">
      </nx-authorization-permissions-wizard>
    </v-dialog>
  </div>
</template>

<script>
import PermissionsWizard from '@/modules/authorization/wizard/PermissionsWizard';
import { resources, resourceHeaders } from '@/modules/authorization/config';
import cloneDeep from 'lodash/cloneDeep';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import Resource from './components/Resource.vue';

export default {
  name: 'nx-authorization-permissions-editor',
  components: {
    [PermissionsWizard.name]: PermissionsWizard,
    [Resource.name]: Resource,
  },
  props: {
    label: {
      type: String,
    },
    value: {
      type: Object,
    },
  },
  data() {
    return {
      tab: 0,
      wizard: false,
    };
  },
  computed: {
    resources() {
      return resources;
    },
    currentResource() {
      return this.resources[this.tab];
    },
    style() {
      if (!this.label) {
        return { 'justify-content': 'flex-end' };
      }
      return null;
    },
  },
  methods: {
    resourceHeaders(resource) {
      if (!resourceHeaders[resource]) {
        console.error(`No permission editor header found for resource: ${resource}`);
        return [];
      }
      const toHeaderItem = item => ({
        text: item ? this.$t(`message.permissions.headers.${item}`) : null,
        value: item,
      });
      return resourceHeaders[resource].map(toHeaderItem).concat({
        value: 'options',
        text: this.$t('message.permissions.headers.options'),
        align: 'center',
        sortable: false,
      });
    },
    resourcePermissions(resource) {
      return this.value[resource];
    },
    onInput(value) {
      const permissions = cloneDeep(this.value);
      Object.keys(value).forEach((resource) => {
        // Ensure resource is present on permissions
        if (typeof permissions[resource] === 'undefined') {
          permissions[resource] = [];
        }
        permissions[resource] = permissions[resource].concat(value[resource]);
        permissions[resource] = uniqWith(permissions[resource], isEqual);
        // Set the tab to the edited resource
        this.tab = this.resources.findIndex(item => item === resource);
      });
      permissions.taxonomies.forEach((permission) => {
        if (permission.taxonomy) {
          permission.taxonomyId = permission.taxonomy.id;
        }
      });
      permissions.contents.forEach((permission) => {
        if (permission.taxonomy) {
          permission.taxonomyId = permission.taxonomy.id;
        }
      });
      permissions.boards.forEach((permission) => {
        if (permission.taxonomy) {
          permission.taxonomyId = permission.taxonomy.id;
        }
      });
      this.$emit('input', permissions);
    },
    deletePermission(resource, permission) {
      const permissions = cloneDeep(this.value);
      const index = this.value[resource].findIndex(item => item === permission);
      permissions[resource].splice(index, 1);
      this.$emit('input', permissions);
    },
  },
};
</script>


<style lang="stylus" scoped>
.nx-authorization-permissions-editor {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
